import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-org-configs',
  templateUrl: './org-configs.component.html',
  styleUrls: ['./org-configs.component.scss']
})
export class OrgConfigsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
